import { globalConfig } from "../config/config"

const ENVIRONMENT = {
  baseUrl: () => globalConfig.get().baseUrl,
  baseIBKUrl: () => globalConfig.get().baseIBKUrl,
  isProduction: () => globalConfig.get().isProduction,
  env: () => globalConfig.get().env,
  timeout: () => globalConfig.get().timeout,
  otpVerificationTimer: () => globalConfig.get().otpVerificationTimer,
  otpResendTimer: () => globalConfig.get().otpResendTimer,
}

export default ENVIRONMENT
